
<div *ngIf="stepOK">
  <div *ngIf="!isMovil; else mobileTemplate" class="containerMarginX flex-container-nowrap containerBack">
    <tech-back
      [direction]="'/portfolios'"
      *ngIf="isback"
      class="back"
    ></tech-back>
  </div>
  <ng-template #mobileTemplate>
  <div class="containerMarginX flex-container-nowrap containerBack">
  <ng-template ngIf="isback; else #noBack">
  <!-- Back + greeting & help -->
   <!--
    <tech-back
        [direction]="'/portfolios'"
        class="back"
        *ngIf="gr.ShowHeaderGreetingAndHelp"
    ></tech-back>
    <tech-greeting-help-header
    #gr
    [ShowGreeting]="false"
    ></tech-greeting-help-header>-->
  </ng-template>
  <ng-template #noBack>
    <!-- Greeting & help -->
     <!--
    <tech-greeting-help-header
      [Name]="clientName"
    ></tech-greeting-help-header>-->
  </ng-template>
  </div>
  </ng-template>

  <div class="gridtop containerMarginX">
    <tech-portfolio-item
      [enableHover]="false"
      class="portfolio-item"
      [item]="portfolioData"
      [enableClick]="false"
      [showBack]="isback && isMovil"
    >
    </tech-portfolio-item>

    <div class="card-white grafico margen2">
      <tech-chart-principal
        *ngIf="!noPortofolios"
        [portfolioCode]="portfolioCode"
        class="w-100"
      ></tech-chart-principal>
    </div>
  </div>
  <!--Div 2 - Información-->
  <div class="containerMarginX">
    <tech-portfolio-data
      *ngIf="!noPortofolios"
      [portfolioCode]="portfolioCode"
      class="w-100"
    ></tech-portfolio-data>
    <div *ngIf="noPortofolios" class="w-100 text-center">
      <div class="my-100">
        <img src="{{ logoUrl }}" class="pointer" />
      </div>
      <h2 class="my-100">{{ 'k001874' | translate }}</h2>
    </div>
  </div>
</div>
